
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Vendor",
    "tableTitle": "Vendor List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/mms/vendor/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC",
                "column": "id"
            }
        },
        add: `${baseUrl}/api/mms/vendor`,
        edit: `${baseUrl}/api/mms/vendor/edit`,
        delete: `${baseUrl}/api/mms/vendor/remove`
    },
    "tableCol": [
        {
            name: 'Company Name',
            selector: row => row.name,
            sortable: true
        },
        {
            name: 'Contact Person',
            selector: row => row.poc,
            sortable: true
        },
        {
            name: 'Contanct Email',
            selector: row => row.email,
            sortable: true
        },
        {
            name: 'Contact Phone',
            selector: row => row.phone,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Company Name',
                    name: 'name',
                    "required": true
                },
                {
                    type: 'text',
                    label: 'Contact Person',
                    name: 'poc',
                    "required": true
                },
                {
                    type: 'email',
                    label: 'Contanct Email',
                    name: 'email',
                    "required": true
                },
                {
                    type: 'number',
                    label: 'Contact Phone',
                    name: 'phone'
                }
            ]
        }
    ],
    "mockData": [{
        "compName": "Kumar",
        "poc": "code007",
        "email": "asds@sf.com",
        "phone": 23123
    }]
}